import styled from 'styled-components';
import theme from '@raptormaps/theme';

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.25rem 0.75rem;
  border-bottom: 1px solid ${theme.colors.slate_200};
`;

export const CardIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: ${theme.colors.info_100};
  border-radius: 6px;
  color: #2563eb;
  flex-shrink: 0;
`;

export const CardBody = styled.div`
  padding: 1rem 1.25rem;
`;
